var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createHook, createStore } from "react-sweet-state";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { load } from "framework/state/loader";
import { NoEntityError, updateByResponseTemp } from "framework/validation/validatableentity";
import { apiGetCountries } from "./endpoint";
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: [], errors: __assign({}, NoEntityError), countries_dict: {} });
var loadCountries = function () { return function (store) {
    var loader = function () { return apiGetCountries(); };
    var stateProducer = function (store, _, response) {
        store.setState(function (draft) {
            updateByResponseTemp(draft, response);
            draft.countries_dict = {};
            for (var _i = 0, _a = draft.entity; _i < _a.length; _i++) {
                var i = _a[_i];
                draft.countries_dict[i.code] = i.name;
            }
        });
    };
    load(store, loader, stateProducer);
}; };
var store = createStore({
    initialState: StateDefaults,
    actions: {
        loadCountries: loadCountries,
    },
    name: "Countries"
});
var useState = createHook(store);
export { StateDefaults as CountriestateDefaults, useState as useCountries, };
